// SidebarSkeleton.js
import React from "react";
import { Skeleton } from "@heroui/skeleton";

const SidebarSkeleton = () => {
  return (
    <div>
      {/* Desktop Sidebar Skeleton: Vertical */}
      <nav className="hidden md:flex md:flex-col items-center justify-center sticky top-0 h-400 shadow-md rounded-lg w-full border bg-white p-6 overflow-auto">
        <ul role="tablist">
          {[...Array(5)].map((_, index) => (
            <li key={index} role="tab" className="sidebar-item mb-2">
              <Skeleton className="h-10 w-full rounded-lg" />
            </li>
          ))}
        </ul>
      </nav>
      {/* Mobile Sidebar Skeleton: Horizontal */}
      <nav className="md:hidden sticky top-0 z-auto rounded-lg w-full p-3 overflow-x-auto">
        <ul role="tablist" className="flex mb-2 whitespace-nowrap">
          {[...Array(5)].map((_, index) => (
            <li key={index} role="tab" className="sidebar-item mr-4">
              <Skeleton className="h-10 w-24 rounded-lg" />
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default SidebarSkeleton;
